module.exports = __webpack_public_path__ + "media/gespraech_konrad.debe689e.mp3";